
import {Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChildren, QueryList} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import {Subscription as RxJsSubscription} from 'rxjs';
import {ErrorService, ExplainErrorsService, SessionService} from '@app/services';
import { environment } from '@env/environment';
import {Credit} from '../credit';
import {CreditService} from '../credit.service';
import { LanguageTabComponent } from '@app/models/language';
@Component({
  selector: 'hpf-credit-form',
  templateUrl: './credit-form.component.html'
})
export class CreditFormComponent implements OnInit, OnDestroy {
  /** The model subscription */
  private modelSubscription: RxJsSubscription;
  /** The credit to inject in the form */
  @Input() credit: Credit;
  /** Called the save button is clicked for a new instance */
  @Output() create = new EventEmitter<Credit>();
  /** Called the save button is clicked for an existing instance */
  @Output() update = new EventEmitter<void>();
  /** Called the delete button is clicked */
  @Output() delete = new EventEmitter<void>();
  /** Set loading state of the form */
  @Input() loading = false;
  /** Enable the deletion button */
  @Input() deletable = true;
	/** Enabled quick form */
	@Input() quickFormEnabled = environment.plugins.quickForm.enabled;
  /** Denotes if deltion in progress */
  deleting = false;
  /** Show delete modal */
  deleteModal = false;
  /** The form group to use */
  form: FormGroup;
  /** Denotes if the form is pending */
  saving = false;
  /** Check permission of update **/
  readOnly = false;
	@ViewChildren(LanguageTabComponent) languageTabs: QueryList<
		LanguageTabComponent
	>;
  /** Constructor */
  constructor(private formBuilder: FormBuilder,
              private errorService: ErrorService,
              public explainErrorsService: ExplainErrorsService,
              private creditService: CreditService,
              private sessionService: SessionService) {
  }
  /** Init */
  async ngOnInit() {
    this.readOnly = !(await this.sessionService.checkPermission(
			'credit',
			'update'
		));

    // Init model
    if(!this.credit) this.credit = new Credit();

    // Create form
    this.form = this.formBuilder.group({

    
    });
    // Update form when model loads or changes
    this.modelSubscription = this.credit.subscribe(() => {
        this.updateForm();
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.modelSubscription.unsubscribe();
  }
  /** Called on form submit */
  async onSubmit(): Promise<void> {
    // Saving flag
    this.saving = true;
    try {
        // Update model
        this.updateModel();
		for (let element of this.languageTabs) {
				await element.submit();
			}
        // Creation or update ?
        if (this.credit.isNew()) {
            // Creation
            const credit: Credit = await this.creditService.create(this.credit.toPayload());
            this.create.next(credit);
        } else {
            // Update
            await this.creditService.update(this.credit.getId(), this.credit.toPayload());
            this.update.next();
        }
    } catch (error) {
        this.errorService.handle(error);
    }
    // Saving flag
    this.saving = false
  }
  /** Update models properties from inputs values */
  private updateModel(): void {
    for (const key of Object.keys(this.form.controls)) {
        this.credit.props[key] = this.form.get(key).value;
    }
  }
  /** Update inputs values from models properties */
  private updateForm(): void {
    this.form.setValue({

         
    });
  }
  /** Called on deletion */
  onDelete(): void {
    this.deleting = true;
    this.creditService.remove(this.credit.getId())
      .then(() => {
        this.delete.next();
      })
      .catch((error) => this.errorService.handle(error))
      .then(() => this.deleting = false);
  }
}
